import React from 'react';
import {connect} from 'react-redux';
import {propExistsAndNonEmpty} from '../../../../util/utils';
import {getSortStrategy} from '../../../../strategies/sortStrategies/sortStrategyFactory';
import ResultCardItem from './resultCardItem/resultCardItem';

import './scoreResultIndex.scss';

class TopScoreResultIndex extends React.Component {
    render() {
        const {filteredResults, selectedFilters, assessment} = this.props;

        let topResults;
        if (propExistsAndNonEmpty(filteredResults)) {
            const sort = getSortStrategy(assessment.resultsConfig);
            const sorted = sort(filteredResults, selectedFilters);

            const results = sorted.map((result, priority) => {
                return (
                    <ResultCardItem
                        // eslint-disable-next-line react/no-array-index-key
                        key={priority}
                        priority={priority}
                        assessment={assessment}
                        result={result}
                    />
                );
            });

            const {defaultDisplayCount} = assessment.resultsConfig;

            topResults = results.slice(0, defaultDisplayCount);
        }

        return <ul className="results-display top">{topResults}</ul>;
    }
}

const mapStateToProps = state => {
    return {
        assessment: state.app.assessment,
        filteredResults: state.session.filteredResults,
        selectedFilters: state.session.selectedFilters.inResults
    };
};

export default connect(mapStateToProps, null)(TopScoreResultIndex);
